import React from 'react';
import { Shield, Award, Users } from 'lucide-react';

const MissionSection = () => {
  const values = [
    {
      icon: Shield,
      title: 'Objektwerterhaltung',
      description: 'Regelmäßige, professionelle Reinigung erhält den Wert Ihrer Immobilie. Wir arbeiten nach festen Standards und dokumentieren jede Leistung.'
    },
    {
      icon: Award,
      title: 'Geprüfte Qualität',
      description: 'Geschulte Teams, vollständig versichert, mit dokumentierten Reinigungsprozessen. Regelmäßige Kontrollen sichern gleichbleibend hohe Standards.'
    },
    {
      icon: Users,
      title: 'Umweltschonende Verfahren',
      description: 'Einsatz zertifizierter, umweltfreundlicher Reinigungsmittel und ressourcenschonende Arbeitsweisen. Schonend für Oberflächen und Umwelt.'
    }
  ];

  return (
    <section id="about" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white via-[#FAFBFC] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20 fade-in">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#0A2846] mb-6 sm:mb-8 tracking-tight px-2">
            Professionelle Gebäudereinigung
          </h2>
          <div 
            className="w-24 sm:w-32 h-2 mx-auto mb-6 sm:mb-8 lg:mb-10 rounded-full"
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)'
            }} 
          />
          <p className="text-lg sm:text-xl lg:text-2xl text-[#1F2937] leading-relaxed max-w-4xl mx-auto font-light px-4">
            Geschultes Personal, moderne Reinigungsmethoden und dokumentierte Prozesse. Wir sorgen dafür, dass Ihre Räume und Immobilien dauerhaft gepflegt bleiben – zuverlässig und professionell.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className="bg-white p-6 sm:p-8 lg:p-12 rounded-2xl shadow-elegant hover:shadow-elegant-hover transition-all duration-500 hover:scale-105 border-t-4 group"
                style={{ 
                  borderImage: 'linear-gradient(90deg, #D4AF37, #FFD700, #F4D03F) 1',
                  borderImageSlice: 1
                }}
              >
                <div 
                  className="w-16 h-16 sm:w-18 sm:h-18 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mb-6 sm:mb-8 group-hover:scale-110 transition-transform duration-500"
                  style={{
                    background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                    boxShadow: '0 10px 30px rgba(212, 175, 55, 0.4)'
                  }}
                >
                  <Icon className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 text-[#0A2846]" />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-[#0A2846] mb-4 sm:mb-5">{value.title}</h3>
                <p className="text-[#1F2937]/80 leading-relaxed text-base sm:text-lg">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;